import * as d3 from "d3";
import * as fc from "d3fc";
import moment from 'moment-timezone';

export default function BuildLineChart(_data, chartID, navigatorChartID, customChartControlData, getAllSyncChart, defaultSamplingSize, afterHowManyDaysWillShowAllDataPoint, defaultBrushRange, intervalGapInDatPoint) {


    console.log("Data CXC  D3FC", _data);

    var globalChartInstance = null;
    _data.series = [_data.series[0].mainPoints, _data.series[0].missingPoints];

    var lastBrushSelectionEvent = null;

    function getSampler(samplerSize) {
        var sampler = fc.largestTriangleThreeBucket();

        // Configure the x / y value accessors
        sampler.x(function (d) {
            return d[_data.xDataAttribute];
        })
            .y(function (d) {
                return d[_data.yDataAttribute]['value'];
            });

        // Size of buck need to define dynamically according
        // to number of record need to render on UI
        sampler.bucketSize(0);
        return sampler;
    }

    let fullSeriesData = [];
    let height = 500;
    // add the X gridlines

    // gridlines in x axis function
    function make_x_gridlines() {
        return d3.axisBottom(x)
            .ticks(3)
    }
    //removing old gridlines when chart is updating 
    function removeOld_x_gridlines() {
        d3.select(chartID).selectAll('.grid').remove();
        return d3.axisBottom(x)
    }

    function generateSamplerData(samplerSize) {
        var sampler = getSampler(samplerSize);
        var _fullSeriesData = [];
        _data.series.forEach(function (value = []) {
            _fullSeriesData.push(sampler(value));
        });

        fullSeriesData = _fullSeriesData;

        console.log("FULL-Series-Data", fullSeriesData);

        return _fullSeriesData;
    }

    generateSamplerData(defaultSamplingSize);

    const yExtent = function (xLeft, xRight, fullData) {
        let linerExtender = fc.extentLinear()
            .accessors([d => {
                if (xLeft && xRight) {
                    if (d[_data.xDataAttribute] >= xLeft && d[_data.xDataAttribute] <= xRight) {
                        return d[_data.yDataAttribute]['value']
                    }
                } else {
                    return d[_data.yDataAttribute]['value']
                }
            }])
            .pad([0.2, 0.2]).bind(this);
        return linerExtender(fullData);
    }

    const xExtent = fc.extentDate()
        .accessors([d => d[_data.xDataAttribute]]);
    console.log("xExtent", xExtent);

    const bisectDate = d3.bisector(function (d) {
        return d[_data.xDataAttribute];
    }).left;

    // create the scales for all series of data,
    // by combine all data across full series
    var x;
    // if (customChartControlData && customChartControlData.scaleType) {
    //     x = d3 && d3.scaleLinear()
    //         .domain(xExtent(fullSeriesData[0]));
    // } else {
    x = d3 && d3.scaleTime()
        .domain(xExtent(fullSeriesData[0]));
    //  }


    console.log("yExtent(null, null, fullSeriesData[0])", yExtent(null, null, fullSeriesData[0]));

    var y = d3.scaleLinear()
        .domain(yExtent(null, null, fullSeriesData[0]));

    // create the data that is bound to the charts. It is a combination of the
    // chart data and the brushed / navigator range
    const chartData = {
        series: fullSeriesData,
        // set an initial brushed range
        brushedRange: [0, 1]
    };

    // We need to see how we can define our custom color
    const color = d3.scaleOrdinal(d3.schemeCategory10);
    //console.log("color", color, d3.schemeCategory10, d3.scaleOrdinal(d3.schemeCategory10));

    let updateChartTimer = null;
    const brush = fc.brushX()
        .on('brush', (evt) => {
            lastBrushSelectionEvent = evt;
            // if the brush has zero height there is no selection
            if (evt.selection) {
                if (updateChartTimer) {
                    clearTimeout(updateChartTimer);
                    updateChartTimer = null;
                }
                updateChartTimer = setTimeout(() => {
                    updateChart(evt);
                }, 500);
            }
        });

    function updateChart(evt) {
        chartData.brushedRange = evt.selection;

        //86400 is the number of seconds in one day
        var recordForNumberOfDay = ((evt.xDomain[1] - evt.xDomain[0]) / 1000) / 86400;

        if (recordForNumberOfDay <= afterHowManyDaysWillShowAllDataPoint) {
            generateSamplerData(1);
        } else {
            generateSamplerData(defaultSamplingSize);
        }
        chartData.series = fullSeriesData;

        // update the domain of the main chart to reflect the brush
        mainChart.xDomain(evt.xDomain);
        console.log("evt.xDomain", evt.xDomain);
        mainChart.yDomain(yExtent(evt.xDomain[0], evt.xDomain[1], fullSeriesData[0]));

        getAllSyncChart().forEach((chart) => {
            if (chart) {
                chart.xDomain(evt.xDomain);
                chart.yDomain(chart.__yExtent(evt.xDomain[0], evt.xDomain[1], chart.__chartData.series[0]));
                if (recordForNumberOfDay <= afterHowManyDaysWillShowAllDataPoint) {
                    chart.__chartData.series = chart.__generateSamplerData(1);
                } else {
                    chart.__chartData.series = chart.__generateSamplerData(defaultSamplingSize);
                }
                chart.__chartData.brushedRange = evt.selection;
                chart.__renderChart(chart.__chartData);
            }
        });
        makeGridLines();
        render(chartData);
    }

    function setInitialDomain() {
        // set the initial domain for the main chart based on the
        // brushed range
        d3.scaleLinear()
            .domain(xExtent(fullSeriesData[0]));
        var scale = d3.scaleTime().domain(x.domain());
        let xDomainValues = chartData.brushedRange.map(scale.invert);
        mainChart.xDomain(xDomainValues);
        mainChart.yDomain(yExtent(xDomainValues[0].getTime(), xDomainValues[1].getTime(), fullSeriesData[0]));
    }

    function getLineDrawer() {
        const _lineDrawer = [];

        fullSeriesData.forEach(function (value, index) {

            var line = fc.seriesSvgLine()
                .crossValue(d => d[_data.xDataAttribute])
                .mainValue(d => {
                    return d[_data.yDataAttribute].nullify ? null : d[_data.yDataAttribute]['value'];
                })
                .decorate(function (sel) {
                    sel.attr('stroke', (_, i) => {
                        let colorx = value && value[0] && value[0][_data.yDataAttribute].color ?
                            value[0][_data.yDataAttribute].color : (customChartControlData && customChartControlData.color ? customChartControlData.color : color(index))
                        //console.log("color", colorx);
                        return colorx;
                    });
                });

            var drawLine = fc.seriesSvgMulti()
                .series([line])
                .mapping((data, index, series) => {
                    return value;
                });

            _lineDrawer.push(drawLine);
        });

        return _lineDrawer;
    }

    var lineDrawer = getLineDrawer();

    var allSeries = [...lineDrawer];
    const allSeriesNavigator = [...lineDrawer];

    // create a multi series, combining the brush and area
    var multiLine = fc.seriesSvgMulti()
        .series(allSeries);

    // create a multi series, combining the brush and area for navigator chart
    const multiLineNavigator = fc.seriesSvgMulti()
        .series([multiLine, brush])
        .mapping((data, index, series) => {
            switch (series[index]) {
                case brush: {
                    return data.brushedRange;
                }
                case multiLine: {
                    return data.series;
                }
            }
        });

    function createButton(buttonName, buttonText, passValue, xposition, rectSize) {

        if (document.getElementById(chartID.replace("#", '') + buttonName)) {
            document.getElementById(chartID.replace("#", '') + buttonName).remove();
        }

        let svg = d3.select(chartID).select('svg');
        let button = svg.append('svg').attr("id", chartID.replace("#", '') + buttonName).attr("x", xposition).append("g").attr("class", chartID.replace("#", '') + buttonName).attr("x", xposition);
        let rect = button.append("rect")
            // .attr("style", "fill:rgb(80,80,83); border-width:1;")
            .attr("class", "PlotButtonCss")
            .attr("width", rectSize)
            .attr("height", 20);

        let text = button.append("text").text(function () {
            return buttonText;
        }).attr("y", 15).attr("x", 2);
        document.querySelector("." + chartID.replace("#", '') + buttonName).addEventListener("click", () => clickEvent(passValue));
    }

    function insertClickableButtonInSVG() {
        setTimeout(function () {
            if (customChartControlData.rangeButtons && customChartControlData.rangeButtons.length > 0) {
                customChartControlData.rangeButtons.forEach((rangeData) => {
                    createButton(rangeData.buttonName, rangeData.buttonText, rangeData.passValue, rangeData.xposition, rangeData.rectSize);
                })
            }
        }, 0);
    }

    function clickEvent(passValue) {

        var minInDay = 1440 * 60 * 1000;
        var minInWeek = 10080 * 60 * 1000;
        var minInMonth = 43800 * 60 * 1000;
        //intervalGapInDatPoint

        if (passValue < 4) {
            generateSamplerData(1);
            mainChart.__chartData.series = fullSeriesData;
        }

        if (!lastBrushSelectionEvent) {
            const date1 = new Date(mainChart.xDomain()[0]);
            const date2 = new Date(mainChart.xDomain()[1]);
            lastBrushSelectionEvent = {};
            lastBrushSelectionEvent.xDomain = [date1.getTime(), date2.getTime()];
            lastBrushSelectionEvent.selection = [0, 1];
            const diffTime = Math.abs(date2 - date1);
        }

        var newDomain;
        var perctangeOfBrushNeedToSelected = null;
        var recordForNumberOfSecond = ((lastBrushSelectionEvent.xDomain[1] - lastBrushSelectionEvent.xDomain[0]));
        var selectedBrushRange = lastBrushSelectionEvent.selection[1] - lastBrushSelectionEvent.selection[0];

        var placeForOneUnitTime = (selectedBrushRange / recordForNumberOfSecond);


        switch (passValue) {
            case 1: {
                perctangeOfBrushNeedToSelected = (placeForOneUnitTime * minInDay);
                mainChart.__chartData.brushedRange = [
                    lastBrushSelectionEvent.selection[1] - perctangeOfBrushNeedToSelected,
                    lastBrushSelectionEvent.selection[1]];
                newDomain = [new Date(new Date(x.domain()[1]).getTime() - minInDay), (x.domain())[1]];
                mainChart.xDomain(newDomain);
                mainChart.yDomain(yExtent(newDomain[0], newDomain[1], fullSeriesData[0]));
                break;
            }

            case 2: {
                perctangeOfBrushNeedToSelected = (placeForOneUnitTime * minInWeek);
                mainChart.__chartData.brushedRange = [
                    lastBrushSelectionEvent.selection[1] - perctangeOfBrushNeedToSelected,
                    lastBrushSelectionEvent.selection[1]];
                newDomain = [new Date(new Date(x.domain()[1]).getTime() - minInWeek), (x.domain())[1]];
                mainChart.xDomain(newDomain);
                mainChart.yDomain(yExtent(newDomain[0], newDomain[1], fullSeriesData[0]));
                break;
            }

            case 3: {
                perctangeOfBrushNeedToSelected = (placeForOneUnitTime * minInMonth);
                mainChart.__chartData.brushedRange = [
                    lastBrushSelectionEvent.selection[1] - perctangeOfBrushNeedToSelected,
                    lastBrushSelectionEvent.selection[1]];

                newDomain = [new Date(new Date(x.domain()[1]).getTime() - minInMonth), (x.domain())[1]];
                mainChart.xDomain(newDomain);
                mainChart.yDomain(yExtent(newDomain[0], newDomain[1], fullSeriesData[0]));
                break;
            }

            case 4: {
                generateSamplerData(defaultSamplingSize);
                mainChart.__chartData.series = fullSeriesData;
                mainChart.__chartData.brushedRange = [0, 1];
                mainChart.xDomain(xExtent(fullSeriesData[0]));
                mainChart.yDomain(yExtent(null, null, fullSeriesData[0]));
                break;
            }
        }

        mainChart.__renderChart(mainChart.__chartData);
        getAllSyncChart().forEach((chart) => {
            if (chart) {
                if (passValue < 4) {
                    let fullSeriesDataClone = chart.__generateSamplerData(1);
                    chart.__chartData.series = fullSeriesDataClone;
                    chart.__chartData.brushedRange = [
                        lastBrushSelectionEvent.selection[1] - perctangeOfBrushNeedToSelected,
                        lastBrushSelectionEvent.selection[1]];
                    chart.xDomain(newDomain);
                    chart.yDomain(chart.__yExtent(newDomain[0], newDomain[1], fullSeriesDataClone[0]));
                } else {
                    let fullSeriesDataClone = chart.__generateSamplerData(defaultSamplingSize);
                    chart.__chartData.series = fullSeriesDataClone;
                    chart.__chartData.brushedRange = [0, 1];
                    chart.xDomain(xExtent(fullSeriesDataClone[0]));
                    chart.yDomain(chart.__yExtent(null, null, fullSeriesDataClone[0]));
                }
                chart.__renderChart(chart.__chartData);
            }
        });
    }

    function makeGridLines() {
        setTimeout(function () {
            /*added to show the gridlines on the chart*/
            d3.select(chartID).select('svg').append("g")
                .call(removeOld_x_gridlines())
                .attr("class", "grid")
                .attr("transform", "translate(0," + height + ")")
                // .style("stroke-dasharray", ("2,6"))
                .call(make_x_gridlines()
                    .tickSize(-height)
                )
                .call(g => g.select(".domain").remove());
        }, 0);
    }

    function insertToolTip(mainChartInstanceInToolTip) {
        setTimeout(function () {
            let svg = d3.select(chartID).select('svg');
            svg.selectAll(".focus").remove();
            let focus = svg.append("g")
                .attr("class", "DisplayNone focus");
            // .style("display", "none");

            focus.append("circle")
                .attr("r", 5);

            focus.append("rect")
                .attr("class", "tooltipCustom")
                .attr("width", 150)
                .attr("height", 40)
                .attr("x", 10)
                .attr("y", -12)
                .attr("rx", 0)
                .attr("ry", 0);

            focus.append("text")
                .attr("class", "tooltip-date")
                .attr("x", 60)
                .attr("y", 5);

            focus.append("text")
                .attr("class", "labelTop")
                .attr("x", 18)
                .attr("y", 5)
                .text(customChartControlData && customChartControlData.topTooltipLabel ? `${customChartControlData.topTooltipLabel} =` : "Date =");

            focus.append("text")
                .attr("class", "labelLike")
                .attr("x", 18)
                .attr("y", 18)
                .text(customChartControlData && customChartControlData.bottomTooltipLabel ? `${customChartControlData.bottomTooltipLabel} =` : "Point =");


            focus.append("text")
                .attr("class", "tooltip-likes")
                .attr("x", 60)
                .attr("y", 18);

            focus.classed("displayBlock", false);
            focus.classed("displayNone", true);


            setTimeout(() => {

                const svgAttribute = svg.node().getBBox();
                const width = svg._groups[0][0].width.animVal.value;
                const height = svg._groups[0][0].height.animVal.value;

                if (document.getElementById(chartID.replace("#", '') + "Overlay")) {
                    document.getElementById(chartID.replace("#", '') + "Overlay").remove();
                }

                svg.append("rect")
                    .attr("id", chartID.replace("#", '') + "Overlay")
                    .attr("class", "overlay")
                    .attr("width", width)
                    .attr("height", height - 21)
                    .attr("y", 20)
                    .on("mouseover", function () {
                        //focus.style("display", "none");
                        //focusOne.style("display", "none");
                        //focusTwo.style("display", "none");
                    })
                    .on("mouseout", function () {

                        focus.classed("DisplayBlock", false);
                        focus.classed("DisplayNone", true);
                        focusOne.classed("DisplayNone", true);
                        focusTwo.classed("DisplayNone", true);
                        
                        // focus.style("display", "none");
                        // focusOne.style("display", "none");
                        // focusTwo.style("display", "none");
                        window.lastTooltipFocus = null;

                        getAllSyncChart().forEach((chart) => {
                            if (chart) {
                                try {
                                    chart.__focus.classed("displayBlock", false);
                                    chart.__focus.classed("DisplayNone", true);
                                    chart.__focusOne.classed("DisplayNone", true);
                                    chart.__focusTwo.classed("DisplayNone", true);
                                    
                                    // chart.__focus.style("display", "none");
                                    // chart.__focusOne.style("display", "none");
                                    // chart.__focusTwo.style("display", "none");
                                } catch (e) {
                                    //
                                }
                            }
                        });
                    })
                    .on("mousemove", mousemove);
            }, 0);


            let focusOne = svg.append("g")
                .attr("class", "DisplayNone focus");
                // .style("display", "none");

            focusOne.append("circle")
                .attr("r", 5);

            let focusTwo = svg.append("g")
                .attr("class", "DisplayNone focus");
                // .style("display", "none");

            focusTwo.append("circle")
                .attr("r", 5);

            mainChartInstanceInToolTip.__focus = focus;
            mainChartInstanceInToolTip.__focusOne = focusOne;
            mainChartInstanceInToolTip.__focusTwo = focusTwo;

            if (window.lastTooltipFocus) {
                let showToolTipOnLeft = false;
                let showToolTipOnTop = false;
                const width = svg._groups[0][0].width.animVal.value;
                const height = svg._groups[0][0].height.animVal.value;

                if (window.lastTooltipFocus[0] > width / 2) {
                    showToolTipOnLeft = true;
                }

                if (window.lastTooltipFocus[1] > height / 2) {
                    showToolTipOnTop = true;
                }

                showToolTip(window.lastTooltipFocus[0], focus, focusOne, focusTwo, showToolTipOnLeft, showToolTipOnTop);
            }

            function mousemove() {
                let showToolTipOnLeft = false;
                let showToolTipOnTop = false;
                const width = svg._groups[0][0].width.animVal.value;
                const height = svg._groups[0][0].height.animVal.value;

                if (d3.mouse(this)[0] > width / 2) {
                    showToolTipOnLeft = true;
                }

                if (d3.mouse(this)[1] > height / 2) {
                    showToolTipOnTop = true;
                }

                //console.log("showToolTipOnTop", showToolTipOnTop);

                window.lastTooltipFocus = d3.mouse(this);
                showToolTip(d3.mouse(this)[0], focus, focusOne, focusTwo, showToolTipOnLeft, showToolTipOnTop);
                getAllSyncChart().forEach((chart) => {
                    if (chart) {
                        chart.__showToolTip(d3.mouse(this)[0], chart.__focus, chart.__focusOne, chart.__focusTwo, showToolTipOnLeft);
                    }
                });
            }
        }, 0);
    }

    function showToolTip(xPoint, focus, focusOne, focusTwo, showToolTipOnLeft, showToolTipOnTop) {
        if (xPoint[0] === 0) {
            focus.classed("DisplayNone", true);
            // focus.style("display", "none");
            return;
        }

        try {
            //focus.style("display", "block");
            focusOne.classed("DisplayNone", true);
            focusTwo.classed("DisplayNone", true);

            // focusOne.style("display", "none");
            // focusTwo.style("display", "none");
        } catch (e) {
            //
        }

        let x0 = x.invert(xPoint),
            i = bisectDate(fullSeriesData[0], x0, 1),
            d0 = fullSeriesData[0][i - 1],
            d1 = fullSeriesData[0][i],
            d = x0 - d0 && d0.date > d1 && d1.date - x0 ? d1 : d0;

        if (fullSeriesData.length > 1) {

            let i1 = bisectDate(fullSeriesData[1], x0, 1),
                d01 = fullSeriesData[1][i1 - 1],
                d11 = fullSeriesData[1][i1];
            if (d01 && d11) {
                let dF1 = x0 - d01.date > d11.date - x0 ? d11 : d01;
                if (focusOne) {
                    //focusOne.attr("transform", "translate(" + x(dF1[_data.xDataAttribute]) + "," + y(dF1[_data.yDataAttribute]['value']) + ")");
                }
            }

        }

        if (fullSeriesData.length > 2) {
            let i2 = bisectDate(fullSeriesData[2], x0, 1),
                d02 = fullSeriesData[2][i2 - 1],
                d12 = fullSeriesData[2][i2];
            if (d02 && d12) {
                let dF2 = x0 - d02.date > d12.date - x0 ? d12 : d02;
                if (focusTwo) {
                    //focusTwo.attr("transform", "translate(" + x(dF2[_data.xDataAttribute]) + "," + y(dF2[_data.yDataAttribute]['value']) + ")");
                }
            }
        }


        try {
            focus.attr("transform", "translate(" + x(d[_data.xDataAttribute]) + "," + y(d[_data.yDataAttribute]['value']) + ")");
            // focus.style("display", "block");
            focus.classed("DisplayBlock", true);
            focus.select(".tooltip-date").text(moment(d[_data.xDataAttribute]).format('YYYY-MM-DD MM:SS'));
            //console.log("Date______Format", d[_data.xDataAttribute], moment(d[_data.xDataAttribute]).format('YYYY-MM-DD MM:SS'))

            // focus.select(".tooltip-date").text(new Date(d[_data.xDataAttribute]).toDateString());
            focus.select(".tooltip-likes").text(d[_data.yDataAttribute]["value"].toFixed(2));
            // focus.select(".tooltip-likes").text(d[_data.yDataAttribute]['value'] + ', ' + dF1[_data.yDataAttribute]['value'] + ', ' + dF2[_data.yDataAttribute]['value']);
            if (showToolTipOnLeft) {
                focus.select(".tooltipCustom").attr('x', 10 - 170);
                focus.select(".labelLike").attr("x", 18 - 170);
                focus.select(".labelTop").attr("x", 18 - 170);
                focus.select(".tooltip-date").attr("x", 60 - 170);
                //focus.select(".tooltip-date").style("float","left");
                focus.select(".tooltip-likes").attr("x", 115 - 170);
                /*
                if(showToolTipOnTop) {
                    focus.select(".tooltipCustom").attr('y', 10);
                    focus.select(".labelLike").attr("y", 18);
                    focus.select(".labelTop").attr("y", 18);
                    focus.select(".tooltip-date").attr("y", 60);
                    focus.select(".tooltip-likes").attr("y", 90);
                }
                 */
            } else {
                focus.select(".tooltipCustom").attr('x', 10);
                focus.select(".labelLike").attr("x", 18);
                focus.select(".labelTop").attr("x", 18);
                focus.select(".tooltip-date").attr("x", 60);
                focus.select(".tooltip-likes").attr("x", 115);
                /*
                if(showToolTipOnTop) {
                    focus.select(".tooltipCustom").attr('y', 10);
                    focus.select(".labelLike").attr("y", 18);
                    focus.select(".labelTop").attr("y", 18);
                    focus.select(".tooltip-date").attr("y", 60);
                    focus.select(".tooltip-likes").attr("y", 90);
                }
                 */
            }
        } catch (e) {
            //
        }
    }

    var mainChart = fc.chartSvgCartesian(x, y)
        .yTickArguments([5])
        .yTickFormat(d3.format("~s"))
        .xTickArguments([3])
        .xTickFormat(function (d) {
            return moment.tz(d[_data.xDataAttribute], customChartControlData.timezone).format("hh:mm:ss")
        })
        .plotArea(multiLine);


    const navigatorChart = fc.chartSvgCartesian(x.copy(), y.copy())
        .plotArea(multiLineNavigator);

    setInitialDomain();

    const render = (_chartData) => {
        //Redefining the chart range on sampling change.
        lineDrawer = getLineDrawer();
        allSeries = [...lineDrawer];
        multiLine = fc.seriesSvgMulti()
            .series(allSeries);

        mainChart = fc.chartSvgCartesian(x, y)
            .yLabel(customChartControlData.yaxislabel)
            .xLabel("Time")
            .yTickArguments([5])
            .yTickFormat(d3.format("~s"))
            .xTickArguments([3])
            .xTickFormat(function (d) {
                return moment.tz(d, customChartControlData.timezone).format("hh:mm:ss")
            })
            .yOrient("left")
            .plotArea(multiLine);

        mainChart.__chartData = _chartData;
        mainChart.__renderChart = render;
        mainChart.__yExtent = yExtent;
        mainChart.__getChartInstance = getChartInstance;
        mainChart.__generateSamplerData = generateSamplerData;

        d3.select(chartID)
            .datum(_chartData.series)
            .call(mainChart);

        d3.select(navigatorChartID)
            .datum(chartData)
            .call(navigatorChart);

        if (!customChartControlData.hideToolTip) {
            insertToolTip(mainChart);
            mainChart.__showToolTip = showToolTip;
        }


        insertClickableButtonInSVG();

        makeGridLines();
        globalChartInstance = mainChart;
        
        return mainChart;
    };
    render(chartData);

    function getChartInstance() {
        return globalChartInstance;
    }

    mainChart.__showToolTip = showToolTip;
    mainChart.__getChartInstance = getChartInstance;
    mainChart.__chartData = chartData;
    mainChart.__renderChart = render;
    mainChart.__generateSamplerData = generateSamplerData;
    mainChart.__yExtent = yExtent;
    return mainChart;
}

window.BuildLineChart = BuildLineChart;
